import API from '@/lib/API.js'
import comun from './comun.js'
const areas = {
    namespaced: true,
    state: {
        Lista: [],
        Filtradas: [],
        Seleccionado: undefined
    },
    mutations: {
        init(state) {
            state.Filtradas = [];
            state.Seleccionado = undefined;
        },
        set(state, payload) {
            state.Lista = payload;
        },
        select(state, payload) {
            state.Seleccionado = payload;
        },
    },
    actions: {
        async set({
            commit,
            getters
        }) {
            let entidades = getters.getAreas();
            if (entidades.length === 0) {
                commit("comun/cargando")
                let data = await API.Areas.traerTodos();
                commit("set", data)
                commit("comun/fincarga")
            }
        },
        select({
            commit
        }, payload) {
            commit("select", payload)
        },
        async guardar({
            commit,
            dispatch,
            state
        }) {
            let data = []
            let str = ""
            if (state.Seleccionado.id_seccional != 0) {
                data = await API.Areas.modificar(state.Seleccionado);
                str += "Seccional modificada"
            } else {
                data = await API.Areas.alta(state.Seleccionado);
                str += `Nueva seccional de alta'${data.Descripcion_seccional}'`
            }
            let secs = await API.Areas.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_seccional)
            commit("comun/mostrar", str)
        },
        async guardarEntidad({
            commit,
            dispatch
        }, entidad) {
            let data = []
            let str = ""
            if (entidad.id_seccional != 0) {
                data = await API.Areas.modificar(entidad);
                str += "Seccional modificada"
            } else {
                data = await API.Areas.alta(entidad);
                str += `Nueva seccional de alta'${data.Descripcion_seccional}'`
            }
            let secs = await API.Areas.traerTodos();
            commit("set", secs)
            dispatch("selectPorId", data.id_seccional)
            commit("comun/mostrar", str)
        },
        async eliminar({
            commit
        }, id) {
            let str = ""
            if (id != 0) {
                await API.Areas.eliminar(id);
                str += "Seccional eliminada"
            }
            let ents = await API.Areas.traerTodos();
            commit("set", ents)
            commit("comun/mostrar", str)
        },
    },
    getters: {
        getAreas: state => () => {
            return state.Lista;
        },
    },
    modules: {
        comun,
    }
}
export default areas;